Ext.define('SA.HistogramData', {
    constructor({binSize, bins}) {
        this.binSize = SA.Math.roundToTwoDecimals(binSize);
        this.bins = bins;

        this.maxCount = Math.max(...Ext.Array.pluck(bins, 'count'));
        this.intervalEdges = SA.Array.unique(Ext.Array.pluck(bins, 'interval').flat());
    },

    getBinSize() {
        return this.binSize;
    },

    getIntervalCount() {
        return this.bins.length;
    },

    getIntervalEdges() {
        return this.intervalEdges;
    },

    getMaxCount() {
        return this.maxCount;
    },

    mapBins(fn) {
        return this.bins.map(fn);
    }
});